'use client';

export { useLocaleContext as useLocale } from '@/context/locale-context';
